import {
  createSearchParamsCache,
  type inferParserType,
  parseAsInteger,
  parseAsString,
} from "nuqs/server"

export const toolFilterParams = {
  q: parseAsString.withDefault(""),
  sort: parseAsString.withDefault(""),
  page: parseAsInteger.withDefault(1),
  perPage: parseAsInteger.withDefault(36),
  category: parseAsString.withDefault(""),
  deliveryModel: parseAsString.withDefault(""),
  capability: parseAsString.withDefault(""),
  entityType: parseAsString.withDefault(""),
  task: parseAsString.withDefault(""),
  language: parseAsString.withDefault(""),
  maintenance: parseAsString.withDefault(""),
  accessModel: parseAsString.withDefault(""),
}

export const toolFilterParamsCache = createSearchParamsCache(toolFilterParams)

export type ToolFilterSchema = typeof toolFilterParams
type ParsedToolFilters = inferParserType<typeof toolFilterParams>
export type ToolFilterParams = Omit<
  ParsedToolFilters,
  | "deliveryModel"
  | "capability"
  | "entityType"
  | "task"
  | "language"
  | "maintenance"
  | "accessModel"
> &
  Partial<
    Pick<
      ParsedToolFilters,
      | "deliveryModel"
      | "capability"
      | "entityType"
      | "task"
      | "language"
      | "maintenance"
      | "accessModel"
    >
  >
